module.exports = __webpack_public_path__ + "img/avatar2.274c0de7.png";